import React, { useRef, useState } from "react";
import { SectionTitle } from "./_components/SectionTitle";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "src/components/ui/breadcrumb";
import { Link } from "react-router-dom";
import { Card } from "../../components/ui/card";
import { Input } from "../../components/ui/input";
import FileUploadImage from "../../components/FileUploadImage";
import { cn } from "../../lib/utils";
import { AnimatePresence, motion } from "framer-motion";
import { Badge } from "../../components/ui/badge";
import { Plus, UploadCloud, X } from "lucide-react";
import { Button } from "../../components/ui/button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../components/ui/select";

export default function MainJobOffer() {
  const programs = [
    "Zoom",
    "Excel",
    "Google form",
    "Word",
    "Powerpoint",
    "Canva",
    // "أخري",
  ];

  const languages = [
    "اللغة العربية",
    "اللغة الانجليزية",
    "اللغة الفرنسية",
    "اللغة الايطالية",
    "اللغة الالمانية",
    "اللغة التركية",
    // "أخري",
  ];

  const [activePrograms, setActivePrograms] = useState([programs[0]]);
  const [activeLanguages, setActiveLanguages] = useState([languages[0]]);

  const [formAcheivement, setFormAcheivement] = useState({
    qualification: "",
    graduationYear: "",
    institution: "",
    courseInput: "",
    courses: [],
  });

  const handleChangeAcheivement = (e) => {
    const { name, value } = e.target;
    setFormAcheivement((prev) => ({ ...prev, [name]: value }));
  };

  const addCourse = () => {
    const trimmed = formAcheivement.courseInput.trim();
    if (trimmed && !formAcheivement.courses.includes(trimmed)) {
      setFormAcheivement((prev) => ({
        ...prev,
        courses: [...prev.courses, trimmed],
        courseInput: "",
      }));
    } else {
      setFormAcheivement((prev) => ({ ...prev, courseInput: "" }));
    }
  };

  const removeCourse = (course) => {
    setFormAcheivement((prev) => ({
      ...prev,
      courses: prev.courses.filter((c) => c !== course),
    }));
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      addCourse();
    }
  };

  // Experience
  const [formExperience, setFormExperience] = useState({
    yearsExperience: "",
    experienceType: "",
    previousInstitutions: "",
    ageCategory: "",
  });
  const [subjectInput, setSubjectInput] = useState("");
  const [subjects, setSubjects] = useState([]);

  const resumeRef = useRef(null);
  const videoRef = useRef(null);
  const docsRef = useRef(null);

  const handleChangeExperience = (e) => {
    const { name, value } = e.target;
    setFormExperience((prev) => ({ ...prev, [name]: value }));
  };

  const addSubject = () => {
    const val = subjectInput.trim();
    if (val && !subjects.includes(val)) {
      setSubjects((prev) => [...prev, val]);
    }
    setSubjectInput("");
  };

  const removeSubject = (subj) => {
    setSubjects((prev) => prev.filter((s) => s !== subj));
  };

  return (
    <div className="space-y-20 max-w-7xl mx-auto px-4 mt-14">
      <div className="space-y-6">
        <Breadcrumb>
          <BreadcrumbList>
            <BreadcrumbItem>
              <BreadcrumbLink asChild>
                <Link to="/">الصفحة الرئيسية</Link>
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbSeparator />

            <BreadcrumbItem>
              <BreadcrumbPage className="font-semibold">عرض عمل</BreadcrumbPage>
            </BreadcrumbItem>
          </BreadcrumbList>
        </Breadcrumb>

        <SectionTitle title={"يمكنك العمل معنا الآن"} />
      </div>

      {/* Form Personal */}
      <Card className="p-6 rounded-xl space-y-4">
        <div className="flex items-center gap-4">
          {personalSVG}
          <p className="font-bold text-2xl">البيانات الشخصية</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {/* Form */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 col-span-1 md:col-span-2">
            <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
              <label htmlFor="fname" className="font-medium text-sm">
                الاسم الأول
              </label>
              <Input id="fname" name="fname" placeholder="محمد" />
            </div>
            <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
              <label htmlFor="lname" className="font-medium text-sm">
                اسم العائلة
              </label>
              <Input id="lname" name="lname" placeholder="أحمد" />
            </div>
            <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
              <label htmlFor="email" className="font-medium text-sm">
                البريد الإلكتروني
              </label>
              <Input
                id="email"
                name="email"
                placeholder="mohamed@example.com"
              />
            </div>
            <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
              <label htmlFor="phone" className="font-medium text-sm">
                رقم الهاتف
              </label>
              <Input id="phone" name="phone" placeholder="01234567890" />
            </div>
            <div className="flex flex-col gap-2 col-span-2">
              <label htmlFor="address" className="font-medium text-sm">
                العنوان
              </label>
              <Input
                id="address"
                name="address"
                placeholder="العنوان (المدينة، الشارع، رقم المبنى)"
              />
            </div>
          </div>

          <div className="flex flex-col justify-between gap-2">
            <label htmlFor="image" className="font-medium text-sm">
              صورة شخصية
            </label>
            <FileUploadImage
              //   onUploadComplete={(url) => setImage(url)}
              //   image={image}
              name={"job-offer"}
              //   disabled={!editMode}
            />
          </div>
        </div>
      </Card>

      {/* Form Skills */}
      <Card className="p-6 rounded-xl space-y-4">
        <div className="flex items-center gap-4">
          {skillsSVG}
          <p className="font-bold text-2xl">المهارات</p>
        </div>

        <div className="space-y-6">
          <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
            <label htmlFor="programs" className="font-medium text-sm">
              البرامج التعليمية
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-5">
              {programs.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    if (activePrograms.includes(item)) {
                      setActivePrograms(
                        activePrograms.filter((program) => program !== item)
                      );
                    } else {
                      setActivePrograms([...activePrograms, item]);
                    }
                  }}
                  className={cn(
                    "rounded-xl text-white h-fit flex items-center justify-center py-2 text-center cursor-pointer transition-colors duration-300 bg-gradient-to-tr from-blue-400 to-blue-700",
                    activePrograms.includes(item)
                      ? ""
                      : "border-2 border-blue-600 bg-clip-text text-transparent"
                  )}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>

          <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
            <label htmlFor="language" className="font-medium text-sm">
              اللغات
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-5">
              {languages.map((item, index) => (
                <div
                  key={index}
                  onClick={() => {
                    if (activeLanguages.includes(item)) {
                      setActiveLanguages(
                        activeLanguages.filter((lang) => lang !== item)
                      );
                    } else {
                      setActiveLanguages([...activeLanguages, item]);
                    }
                  }}
                  className={cn(
                    "rounded-xl text-white h-fit flex items-center justify-center py-2 text-center cursor-pointer transition-colors duration-300 bg-gradient-to-tr from-blue-400 to-blue-700",
                    activeLanguages.includes(item)
                      ? ""
                      : "border-2 border-blue-600 bg-clip-text text-transparent"
                  )}
                >
                  {item}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Card>

      {/* Form Achivemnet */}
      <Card className="p-6 rounded-xl space-y-4">
        <div className="flex items-center gap-4">
          {achivementSVG}
          <p className="font-bold text-2xl"> المؤهلات العلمية</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
            <label htmlFor="qualification" className="font-medium text-sm">
              المؤهل الدراسي
            </label>
            <Input
              id="qualification"
              name="qualification"
              placeholder="بكالوريوس/دبلوم/..."
              value={formAcheivement.qualification}
              onChange={handleChangeAcheivement}
            />
          </div>

          <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
            <label htmlFor="graduationYear" className="font-medium text-sm">
              سنة التخرج
            </label>
            <Input
              id="graduationYear"
              name="graduationYear"
              placeholder="2024"
              value={formAcheivement.graduationYear}
              onChange={handleChangeAcheivement}
            />
          </div>

          <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
            <label htmlFor="institution" className="font-medium text-sm">
              الجامعة / المعهد
            </label>
            <Input
              id="institution"
              name="institution"
              placeholder="اسم الجامعة أو المعهد"
              value={formAcheivement.institution}
              onChange={handleChangeAcheivement}
            />
          </div>

          <div className="flex flex-col gap-2 col-span-2 md:col-span-1">
            <label htmlFor="courseInput" className="font-medium text-sm">
              الدورات التدريبية
            </label>
            <div className="flex items-center gap-2">
              <Input
                id="courseInput"
                name="courseInput"
                placeholder="أدخل اسم الدورة"
                value={formAcheivement.courseInput}
                onChange={handleChangeAcheivement}
                onKeyDown={handleKeyDown}
              />
              <Button
                type="button"
                onClick={addCourse}
                variant="outline"
                className="p-2"
              >
                <Plus className="w-4 h-4" />
              </Button>
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
              {formAcheivement.courses.map((course) => (
                <Badge key={course} className="flex items-center gap-1">
                  <span>{course}</span>
                  <X
                    className="w-4 h-4 cursor-pointer"
                    onClick={() => removeCourse(course)}
                  />
                </Badge>
              ))}
            </div>
          </div>
        </div>
      </Card>

      {/* Form Experience */}
      <Card className="p-6 rounded-xl space-y-4">
        <div className="flex items-center gap-4">
          {experienceSVG}
          <p className="font-bold text-2xl"> المؤهلات العلمية</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          {/* عدد سنوات الخبرة */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">عدد سنوات الخبرة</label>
            <Input
              name="yearsExperience"
              placeholder="اكتب هنا"
              value={formAcheivement.yearsExperience}
              onChange={handleChangeExperience}
            />
          </div>

          {/* نوع الخبرة */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">نوع الخبرة</label>
            <Select
              onValueChange={(val) =>
                setFormExperience((prev) => ({ ...prev, experienceType: val }))
              }
              defaultValue=""
            >
              <SelectTrigger>
                <SelectValue placeholder="اختر" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="online">أونلاين</SelectItem>
                <SelectItem value="offline">أوفلاين</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* المؤسسات السابقة */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">المؤسسات السابقة</label>
            <Input
              name="previousInstitutions"
              placeholder="اكتب هنا"
              value={formAcheivement.previousInstitutions}
              onChange={handleChangeExperience}
            />
          </div>

          {/* الفئات العمرية */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">الفئات العمرية</label>
            <Select
              onValueChange={(val) =>
                setFormExperience((prev) => ({ ...prev, ageCategory: val }))
              }
              defaultValue=""
            >
              <SelectTrigger>
                <SelectValue placeholder="اختر" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="kids">الأطفال</SelectItem>
                <SelectItem value="teens">المراهقين</SelectItem>
                <SelectItem value="adults">البالغين</SelectItem>
              </SelectContent>
            </Select>
          </div>

          {/* المواد التي قام بتدريسها */}
          <div className="col-span-1 md:col-span-4 flex flex-col gap-2">
            <label className="font-medium text-sm">
              المواد التي قام بتدريسها
            </label>
            <div className="flex items-center gap-2">
              <Input
                placeholder="أدخل مادة"
                value={subjectInput}
                onChange={(e) => setSubjectInput(e.target.value)}
                onKeyDown={(e) =>
                  e.key === "Enter" && (e.preventDefault(), addSubject())
                }
              />
              <Button variant="outline" onClick={addSubject} className="p-2">
                <Plus className="w-4 h-4" />
              </Button>
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
              {subjects.map((subj) => (
                <Badge key={subj} className="flex items-center gap-1">
                  <span>{subj}</span>
                  <X
                    className="w-4 h-4 cursor-pointer"
                    onClick={() => removeSubject(subj)}
                  />
                </Badge>
              ))}
            </div>
          </div>

          {/* السيرة الذاتية */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">السيرة الذاتية</label>
            <div
              className="border rounded flex items-center gap-2 p-2 cursor-pointer"
              onClick={() => resumeRef.current?.click()}
            >
              <UploadCloud className="w-5 h-5" />
              <span>ارفع الملف هنا</span>
            </div>
            <input ref={resumeRef} type="file" className="hidden" />
          </div>

          {/* فيديو تجريبي */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">
              فيديو تجريبي (10 : 15 دقيقة)
            </label>
            <div
              className="border rounded flex items-center gap-2 p-2 cursor-pointer"
              onClick={() => videoRef.current?.click()}
            >
              <UploadCloud className="w-5 h-5" />
              <span>ارفع الملف هنا</span>
            </div>
            <input ref={videoRef} type="file" className="hidden" />
          </div>

          {/* مستندات أخرى */}
          <div className="flex flex-col gap-2">
            <label className="font-medium text-sm">مستندات أخرى</label>
            <div
              className="border rounded flex items-center gap-2 p-2 cursor-pointer"
              onClick={() => docsRef.current?.click()}
            >
              <UploadCloud className="w-5 h-5" />
              <span>ارفع الملف هنا</span>
            </div>
            <input ref={docsRef} type="file" className="hidden" multiple />
          </div>
        </div>
      </Card>
    </div>
  );
}

const personalSVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.5 17.9896H61.81V8.67961C61.81 6.99961 60.41 5.59961 58.73 5.59961H6.58C4.9 5.59961 3.5 6.99961 3.5 8.67961V17.9896Z"
      fill="#65CCD8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.8613 17.9896H61.8113V8.67961C61.8113 6.99961 60.4113 5.59961 58.7312 5.59961H52.7812C54.4613 5.59961 55.8613 6.99961 55.8613 8.67961V17.9896Z"
      fill="#58B0BA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.58 58.6596H58.73C60.41 58.6596 61.81 57.2596 61.81 55.5796V16.7296H3.5V55.5796C3.5 57.2596 4.9 58.6596 6.58 58.6596Z"
      fill="#E5F2FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.8613 16.7295V55.5795C55.8613 57.2595 54.4613 58.6595 52.7812 58.6595H58.7312C60.4113 58.6595 61.8113 57.2595 61.8113 55.5795V16.7295H55.8613Z"
      fill="#CDD9E6"
    />
    <path
      d="M11.1997 11.1291C11.1997 11.8291 10.6397 12.3891 9.93969 12.3891C9.23969 12.3891 8.67969 11.8291 8.67969 11.1291C8.67969 10.4291 9.23969 9.86914 9.93969 9.86914C10.6397 9.86914 11.1997 10.4291 11.1997 11.1291Z"
      fill="#FA5C6F"
    />
    <path
      d="M17.5708 11.1291C17.5708 11.8291 17.0108 12.3891 16.3108 12.3891C15.6108 12.3891 15.0508 11.8291 15.0508 11.1291C15.0508 10.4291 15.6108 9.86914 16.3108 9.86914C17.0108 9.86914 17.5708 10.4291 17.5708 11.1291Z"
      fill="#B1DBFC"
    />
    <path
      d="M55.3706 9.86914C56.0706 9.86914 56.6306 10.4291 56.6306 11.1291C56.6306 11.8291 56.0706 12.3891 55.3706 12.3891H36.4006C35.7006 12.3891 35.1406 11.8291 35.1406 11.1291C35.1406 10.4291 35.7006 9.86914 36.4006 9.86914H55.3706Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.6508 38.8496C52.9908 41.7896 49.4208 44.1696 44.8008 45.9196C45.0808 54.8096 49.6308 60.1996 55.6508 64.3996C61.6708 60.1996 66.2208 54.8096 66.5008 45.9196C61.8808 44.1696 58.3108 41.7896 55.6508 38.8496Z"
      fill="#65CCD8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.6502 38.8496C54.9502 39.6196 54.1802 40.3196 53.4102 41.0196C55.5802 43.1196 57.2602 45.2196 60.5502 46.6196C62.2302 47.3196 62.3002 48.0196 62.1602 49.9096C61.6702 54.9496 58.3802 58.7296 54.8102 63.8396C55.0902 64.0496 55.3702 64.2596 55.7202 64.4696C61.7402 60.2696 66.2902 54.8796 66.5702 45.9896C61.8802 44.1696 58.3102 41.7896 55.6502 38.8496Z"
      fill="#58B0BA"
    />
    <path
      d="M51.5888 53.1994C51.0288 52.7794 50.9588 51.9394 51.4488 51.3794C51.9388 50.8194 52.7088 50.7494 53.2688 51.2394L54.5288 52.2894L57.9588 48.2294C58.3788 47.6694 59.2188 47.5994 59.7788 48.0894C60.3388 48.5094 60.4088 49.3494 59.9188 49.9094L55.6488 54.9494C55.1588 55.5094 54.3888 55.5794 53.8288 55.0894L51.5888 53.1994Z"
      fill="white"
    />
    <path
      d="M35.0002 36.4692C34.3002 36.4692 33.7402 35.9092 33.7402 35.2092C33.7402 34.5092 34.3002 33.9492 35.0002 33.9492H50.2602C50.9602 33.9492 51.5202 34.5092 51.5202 35.2092C51.5202 35.9092 50.9602 36.4692 50.2602 36.4692H35.0002ZM42.5602 39.5492C43.2602 39.5492 43.8202 40.1092 43.8202 40.8092C43.8202 41.5092 43.2602 42.0692 42.5602 42.0692H35.0002C34.3002 42.0692 33.7402 41.5092 33.7402 40.8092C33.7402 40.1092 34.3002 39.5492 35.0002 39.5492H42.5602Z"
      fill="#877F87"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2691 50.6096H28.7691C29.5391 50.6096 30.0991 49.9796 30.0991 49.2796V43.8896C30.0991 40.1796 27.0891 37.1696 23.3791 37.1696H16.5891C12.8791 37.1696 9.86914 40.1796 9.86914 43.8896V49.2796C9.86914 49.9796 10.4991 50.6096 11.2691 50.6096Z"
      fill="#FA5C6F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5996 37.1697C23.3096 37.1697 26.3196 40.1797 26.3196 43.8897V49.2797C26.3196 50.0497 25.6896 50.6097 24.9896 50.6097H28.8396C29.6096 50.6097 30.1696 49.9797 30.1696 49.2797V43.8897C30.1696 40.1797 27.1596 37.1697 23.4496 37.1697H19.5996Z"
      fill="#CC4F5E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.2793 31.9899C14.2793 35.1399 16.8693 37.7299 20.0193 37.7299C23.1693 37.7299 25.7593 35.1399 25.7593 31.9899V29.3999C25.7593 26.2499 23.1693 23.6599 20.0193 23.6599C16.8693 23.6599 14.2793 26.2499 14.2793 29.3999V31.9899Z"
      fill="#FFDDCE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0178 37.7299C23.1678 37.7299 25.7578 35.1399 25.7578 31.9899V29.3999C25.7578 26.2499 23.1678 23.6599 20.0178 23.6599C19.5978 23.6599 19.1778 23.7299 18.7578 23.7999C21.3478 24.3599 23.2378 26.6699 23.2378 29.3999V31.9899C23.2378 34.7199 21.3478 37.0299 18.7578 37.5899C19.1778 37.6599 19.5978 37.7299 20.0178 37.7299Z"
      fill="#F5CFBF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.63 30.0296H54.74C55.09 30.0296 55.37 29.7496 55.37 29.3996V24.2196C55.37 23.8696 55.09 23.5896 54.74 23.5896H35.63C35.28 23.5896 35 23.8696 35 24.2196V29.3996C35 29.7496 35.28 30.0296 35.63 30.0296Z"
      fill="#FEE97E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M51.5187 24.2196V29.3996C51.5187 29.7496 51.2387 30.0296 50.8887 30.0296H54.7387C55.0887 30.0296 55.3687 29.7496 55.3687 29.3996V24.2196C55.3687 23.8696 55.0887 23.5896 54.7387 23.5896H50.8887C51.2387 23.5896 51.5187 23.8696 51.5187 24.2196Z"
      fill="#E6D373"
    />
    <path
      d="M23.9399 11.1291C23.9399 11.8291 23.3799 12.3891 22.6799 12.3891C21.9799 12.3891 21.4199 11.8291 21.4199 11.1291C21.4199 10.4291 21.9799 9.86914 22.6799 9.86914C23.3799 9.86914 23.9399 10.4291 23.9399 11.1291Z"
      fill="#FEE97E"
    />
  </svg>
);

const skillsSVG = (
  <svg
    width="55"
    height="55"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.5335 7.62508C44.4306 8.31455 47.1976 9.46313 49.7335 11.0246L55.062 8.65799L61.3422 14.938L58.9762 20.2647C60.5382 22.801 61.6868 25.569 62.3764 28.4669L67.8126 30.5594V39.4406L62.3751 41.5335C61.6856 44.4307 60.5369 47.1976 58.9755 49.7335L61.3422 55.0618L55.0621 61.342L49.7354 58.9761C47.1991 60.5381 44.4311 61.6867 41.5332 62.3762L39.4408 67.8125H30.5595L28.4665 62.3751C25.5693 61.6856 22.8024 60.537 20.2665 58.9755L14.938 61.3422L8.65785 55.0621L11.0238 49.7354C9.46176 47.1991 8.31318 44.431 7.62371 41.5332L2.1875 39.4408V30.5594L7.62439 28.4666C8.31387 25.5693 9.46258 22.8018 11.0242 20.266L8.65785 14.938L14.9379 8.65785L20.2664 11.0245C22.8022 9.46299 25.5693 8.31441 28.4663 7.62494L30.5595 2.1875H39.4406L41.5335 7.62508Z"
      fill="#837683"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2661 58.9755L14.9376 61.3422L14.1172 60.5217L19.1129 58.3029C19.4923 58.5364 19.8769 58.7606 20.2661 58.9755ZM41.5331 7.62508C44.4302 8.31455 47.1972 9.46313 49.7331 11.0246L48.2185 11.6972C45.6828 10.1359 41.7625 8.31455 38.8655 7.62508L36.7724 2.1875H39.4402L41.5331 7.62508ZM49.7349 58.9762C47.1986 60.5382 44.4306 61.6868 41.5327 62.3763L39.4404 67.8125H36.7726L38.8651 62.3763C41.7628 61.6868 45.684 59.8654 48.2202 58.3034L49.7349 58.9762ZM14.1172 9.4783L14.9376 8.65785L20.2661 11.0245C19.8769 11.2394 19.4923 11.4636 19.113 11.6971L14.1172 9.4783ZM53.2142 9.4783L55.0616 8.65785L61.3418 14.9379L58.9758 20.2646C60.5379 22.8009 61.6864 25.5689 62.376 28.4668L67.8122 30.5592V39.4405L62.3747 41.5334C61.6852 44.4306 60.5365 47.1975 58.9752 49.7334L61.3418 55.0617L55.0617 61.3419L53.2144 60.5214L58.674 55.0617L56.3074 49.7334C57.8687 47.1975 59.0174 44.4306 59.7069 41.5334L65.1443 39.4405V30.5592L59.7081 28.4668C59.0186 25.5689 57.8699 22.8007 56.308 20.2646L58.674 14.9379L53.2142 9.4783Z"
      fill="#685E68"
    />
    <path
      d="M35.0006 50.4885C43.5548 50.4885 50.4895 43.5539 50.4895 34.9996C50.4895 26.4453 43.5548 19.5107 35.0006 19.5107C26.4463 19.5107 19.5117 26.4453 19.5117 34.9996C19.5117 43.5539 26.4463 50.4885 35.0006 50.4885Z"
      fill="#ECEFF1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M47.7371 34.9996C47.7371 38.1681 46.7858 41.1142 45.1531 43.5682C44.5231 44.5152 43.7915 45.389 42.9741 46.1738C40.501 48.5482 37.2415 50.1096 33.625 50.428C34.0786 50.468 34.5379 50.4885 35.0019 50.4885C35.7545 50.4885 36.4946 50.4347 37.2185 50.3311C37.312 50.3177 37.4051 50.3035 37.498 50.2885C44.8655 49.0949 50.4909 42.7043 50.4909 34.9996C50.4909 26.4453 43.5564 19.5107 35.002 19.5107C34.538 19.5107 34.0788 19.5311 33.6251 19.5712C41.5343 20.2678 47.7371 26.9093 47.7371 34.9996Z"
      fill="#D1D1D6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M35.0008 36.4934C29.4213 36.4934 24.8278 40.721 24.2461 46.1462C27.032 48.8347 30.8232 50.4886 35.0008 50.4886C35.7534 50.4886 36.4935 50.4349 37.2174 50.3313C40.5115 49.8592 43.4708 48.3501 45.7548 46.1459C45.174 40.7195 40.5811 36.4934 35.0008 36.4934Z"
      fill="#8AC9FE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.623 36.5802C40.0615 37.3984 42.6561 42.2702 43.2527 48.1084C44.1533 47.5402 44.9911 46.8816 45.7537 46.1456C45.1729 40.7195 40.5801 36.4933 34.9998 36.4933C34.5333 36.4934 34.0738 36.523 33.623 36.5802Z"
      fill="#60B7FF"
    />
    <path
      d="M36.8238 35.3811C39.675 34.3813 41.1759 31.2596 40.1762 28.4084C39.1765 25.5572 36.0547 24.0563 33.2035 25.0561C30.3523 26.0558 28.8515 29.1775 29.8512 32.0287C30.8509 34.8799 33.9727 36.3808 36.8238 35.3811Z"
      fill="#F6DCCD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.0929 30.207C39.0929 32.9942 37.0079 35.2943 34.3125 35.6329C34.5379 35.6612 34.7678 35.6758 35.0009 35.6758C38.0211 35.6758 40.4696 33.2274 40.4696 30.207C40.4696 27.1868 38.0211 24.7383 35.0009 24.7383C34.7678 24.7383 34.5379 24.7529 34.3125 24.7812C37.0079 25.1197 39.0929 27.4199 39.0929 30.207Z"
      fill="#F1CBBC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.2871 30.6484H60.5813V33.341C60.5813 34.2239 59.8588 34.9463 58.9759 34.9463H56.8925C56.0095 34.9463 55.2871 34.2239 55.2871 33.341V30.6484Z"
      fill="#A0A0A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M53.6406 26.7715H62.2277V30.13C62.2277 31.013 61.5052 31.7353 60.6224 31.7353H55.2461C54.3629 31.7353 53.6406 31.013 53.6406 30.13V26.7715Z"
      fill="#B1B1B5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M60.3572 26.2842V30.1301C60.3572 31.0082 59.6398 31.7354 58.752 31.7354H60.622C61.5049 31.7354 62.2272 31.0131 62.2272 30.1301V26.2832C61.6163 26.3033 60.9719 26.2842 60.3572 26.2842Z"
      fill="#A0A0A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.0352 23.7097H63.8329V26.9186C63.8329 27.8016 63.1105 28.524 62.2277 28.524H53.6405C52.7576 28.524 52.0352 27.8016 52.0352 26.9186V23.7097Z"
      fill="#D1D1D6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M61.9626 25.3135V26.7713V26.9191C61.9626 27.802 61.2402 28.5245 60.3574 28.5245H62.2275C62.2454 28.5245 62.2631 28.5242 62.2809 28.5235C63.1394 28.4951 63.8327 27.7841 63.8327 26.9191L63.8328 25.3135H61.9626Z"
      fill="#B1B1B5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57.9338 2.1875C63.39 2.1875 67.8131 6.61063 67.8131 12.0668C67.8131 17.5536 64.3081 17.2256 63.8329 25.3132H52.035C51.5596 17.2256 48.0547 17.5536 48.0547 12.0668C48.0546 6.61063 52.4777 2.1875 57.9338 2.1875Z"
      fill="#FFE177"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M57 2.23111C62.0177 2.70211 65.9443 6.9259 65.9443 12.0668C65.9443 17.1633 62.9202 17.2428 62.109 23.7098C62.0468 24.2051 61.9978 24.7379 61.9638 25.3132H63.8339C64.3093 17.2256 67.8143 17.5536 67.8143 12.0668C67.8143 6.61063 63.3912 2.1875 57.935 2.1875C57.6197 2.1875 57.3079 2.20227 57 2.23111Z"
      fill="#FFD064"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.1344 25.3129V15.5288H53.9324C52.9991 15.5288 52.1515 15.1478 51.5377 14.534C50.924 13.9203 50.543 13.0726 50.543 12.1394C50.543 11.2062 50.924 10.3585 51.5377 9.74477C52.1515 9.13104 52.9991 8.75 53.9324 8.75C54.8656 8.75 55.7133 9.13104 56.327 9.74477C56.9409 10.3586 57.3218 11.2062 57.3218 12.1394V13.3413H58.5463V12.1394C58.5463 11.2062 58.9274 10.3585 59.5411 9.74477C60.155 9.13104 61.0025 8.75 61.9357 8.75C62.869 8.75 63.7166 9.13104 64.3304 9.74477C64.9442 10.3586 65.3251 11.2062 65.3251 12.1394C65.3251 13.0726 64.9441 13.9203 64.3304 14.534C63.7165 15.1479 62.869 15.5288 61.9357 15.5288H60.7337V25.3129H58.5462V15.5288H57.3216V25.3129H55.1344ZM55.1344 13.3413V12.1394C55.1344 11.81 54.9988 11.5097 54.7804 11.2913C54.5621 11.073 54.2617 10.9374 53.9324 10.9374C53.603 10.9374 53.3026 11.073 53.0843 11.2913C52.866 11.5097 52.7303 11.81 52.7303 12.1394C52.7303 12.4688 52.8658 12.769 53.0843 12.9873C53.3026 13.2057 53.603 13.3413 53.9324 13.3413H55.1344ZM60.734 13.3413H61.936C62.2654 13.3413 62.5657 13.2057 62.7841 12.9873C63.0024 12.769 63.1381 12.4686 63.1381 12.1394C63.1381 11.81 63.0024 11.5097 62.7841 11.2913C62.5657 11.073 62.2654 10.9374 61.936 10.9374C61.6067 10.9374 61.3063 11.073 61.088 11.2913C60.8696 11.5097 60.734 11.81 60.734 12.1394V13.3413Z"
      fill="#FFD064"
    />
    <path
      d="M13.1176 67.8125C19.1542 67.8125 24.0477 62.9189 24.0477 56.8824C24.0477 50.8458 19.1542 45.9523 13.1176 45.9523C7.08108 45.9523 2.1875 50.8458 2.1875 56.8824C2.1875 62.9189 7.08108 67.8125 13.1176 67.8125Z"
      fill="#8AC9FE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.119 45.9523C19.1555 45.9523 24.0491 50.8458 24.0491 56.8824C24.0491 62.9189 19.1555 67.8125 13.119 67.8125C12.8199 67.8125 12.5236 67.8001 12.2305 67.7764C17.8514 67.3241 22.2721 62.6198 22.2721 56.8824C22.2721 51.1451 17.8515 46.4406 12.2305 45.9884C12.5236 45.9647 12.8199 45.9523 13.119 45.9523Z"
      fill="#60B7FF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6825 57.8469L16.9972 52.4792C17.6264 51.8439 18.6527 51.842 19.2863 52.4721C19.9197 53.102 19.9217 54.1254 19.2933 54.7597C17.1382 56.9347 14.9975 59.1243 12.8323 61.2895C12.1993 61.9225 11.1726 61.9225 10.5396 61.2895L6.94741 57.6974C6.3144 57.0643 6.3144 56.0376 6.94741 55.4047C7.58028 54.7717 8.60718 54.7717 9.24005 55.4047L11.6825 57.8469Z"
      fill="#ECEFF1"
    />
  </svg>
);

const achivementSVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.85547 16.6031H33.6578C33.6578 10.0967 34.6846 5.27051 27.5232 4.65117C27.1787 4.61973 26.8998 4.42695 26.7521 4.1125C26.6045 3.79805 26.6359 3.45352 26.8369 3.17051L28.0264 1.48477C28.2355 1.18672 28.2588 0.825781 28.092 0.508594C27.9266 0.185938 27.6203 0 27.2607 0H18.6379C12.5484 0 6.85547 3.89102 6.85547 10.433V16.6031Z"
      fill="#231915"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.2084 14.2502H31.3062C32.601 14.2502 33.6592 15.3084 33.6592 16.6032V19.5987C33.6592 20.8934 32.601 21.9516 31.3062 21.9516H9.2084C7.91367 21.9516 6.85547 20.8934 6.85547 19.5987V16.6032C6.85547 15.3084 7.91367 14.2502 9.2084 14.2502Z"
      fill="#E2AA73"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9904 25.803H25.5861V29.9346C25.5861 31.9622 26.6949 33.6971 28.5311 34.5543C33.4994 36.8717 40.4789 37.4145 40.4789 43.8471V50.56C40.4789 51.0754 40.0564 51.4979 39.541 51.4979H1.03555C0.520117 51.4979 0.0976562 51.0754 0.0976562 50.56V43.8471C0.0976562 37.4131 7.07715 36.8717 12.0455 34.5543C13.883 33.6985 14.9904 31.9622 14.9904 29.9346V25.803Z"
      fill="#FFD400"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9895 25.803H25.5852V29.9346C25.5852 31.4262 26.1854 32.7592 27.2367 33.7053C26.2523 36.5969 23.5002 38.6887 20.2873 38.6887C17.0744 38.6887 14.3236 36.5956 13.3379 33.7053C14.3879 32.7592 14.9895 31.4262 14.9895 29.9346V25.803Z"
      fill="#FBBD80"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.9891 25.803H25.5848V29.9346C25.5848 30.1903 25.6039 30.4418 25.6395 30.6907C24.0973 31.5083 22.3418 31.9772 20.4811 31.9772H20.0354C18.1951 31.9772 16.4588 31.5206 14.9316 30.718C14.9699 30.4624 14.9904 30.2026 14.9904 29.9346V25.803H14.9891Z"
      fill="#E2AA73"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.493 10.1815L23.7945 11.0497C24.4877 11.5145 25.2014 11.7319 26.0312 11.7319H26.7941C28.3951 11.7319 29.7008 13.0334 29.7008 14.6344V20.9481C29.7008 26.0176 25.55 30.1684 20.4805 30.1684H20.0348C14.9652 30.1684 10.8145 26.0176 10.8145 20.9481V14.6344C10.8145 13.0334 12.1201 11.7319 13.7211 11.7319H14.484C15.3139 11.7319 16.0262 11.5145 16.7207 11.0497L18.0195 10.1815C19.4045 9.25591 21.1135 9.25591 22.493 10.1815Z"
      fill="#FBBD80"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.64277 51.4978V42.1845C2.64277 40.0572 3.40566 38.5724 4.60742 37.4568C2.04121 38.6968 0.0957031 40.4523 0.0957031 43.847V50.5599C0.0957031 51.0753 0.518164 51.4978 1.03359 51.4978H2.64277Z"
      fill="#E6BF00"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.6664 5.62048H48.0068C48.5537 5.62048 48.9994 6.06619 48.9994 6.61306V13.9535C48.9994 14.4963 48.5537 14.9461 48.0068 14.9461H40.6664C40.1236 14.9461 39.6738 14.4963 39.6738 13.9535V6.61169C39.6738 6.06619 40.1236 5.62048 40.6664 5.62048Z"
      fill="#0593FC"
    />
    <path
      d="M53.3975 8.32893C52.774 8.32893 52.2695 7.82581 52.2695 7.201C52.2695 6.57756 52.774 6.06897 53.3975 6.06897H68.8727C69.4961 6.06897 70.0006 6.5762 70.0006 7.201C70.0006 7.82444 69.4961 8.32893 68.8727 8.32893H53.3975Z"
      fill="#70DA40"
    />
    <path
      d="M53.3975 14.4908C52.774 14.4908 52.2695 13.9863 52.2695 13.3629C52.2695 12.7394 52.774 12.2308 53.3975 12.2308H61.4734C62.0969 12.2308 62.6014 12.7381 62.6014 13.3629C62.6014 13.9863 62.0969 14.4908 61.4734 14.4908H53.3975Z"
      fill="#70DA40"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.6664 19.5098H48.0068C48.5537 19.5098 48.9994 19.9555 48.9994 20.5023V27.8428C48.9994 28.3896 48.5537 28.8354 48.0068 28.8354H40.6664C40.1236 28.8354 39.6738 28.3896 39.6738 27.8428V20.5023C39.6738 19.9555 40.1236 19.5098 40.6664 19.5098Z"
      fill="#0593FC"
    />
    <path
      d="M53.3975 22.2181C52.774 22.2181 52.2695 21.7136 52.2695 21.0902C52.2695 20.4668 52.774 19.9623 53.3975 19.9623H68.8727C69.4961 19.9623 70.0006 20.4668 70.0006 21.0902C70.0006 21.7136 69.4961 22.2181 68.8727 22.2181H53.3975Z"
      fill="#70DA40"
    />
    <path
      d="M53.3975 28.3814C52.774 28.3814 52.2695 27.8769 52.2695 27.2535C52.2695 26.6301 52.774 26.1215 53.3975 26.1215H61.4734C62.0969 26.1215 62.6014 26.6287 62.6014 27.2535C62.6014 27.8769 62.0969 28.3814 61.4734 28.3814H53.3975Z"
      fill="#70DA40"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36.4453 52.8773H48.7691V69.4572C48.7691 69.6664 48.6611 69.8441 48.4752 69.9371C48.2893 70.0342 48.0801 70.015 47.9092 69.8947L42.9258 66.2785C42.7316 66.139 42.4842 66.139 42.29 66.2785L37.3066 69.8947C37.1357 70.015 36.9266 70.0342 36.7406 69.9371C36.5547 69.8441 36.4467 69.6664 36.4467 69.4572V52.8773H36.4453Z"
      fill="#FEA832"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M44.0137 33.1858L45.2729 34.4573C45.7842 34.9727 46.5088 35.1313 47.187 34.8756L48.2452 34.4805C49.2528 34.1046 50.3493 34.6747 50.6241 35.7124L51.0821 37.4405C51.268 38.146 51.8149 38.6422 52.5313 38.7626L53.6442 38.9485C54.7065 39.1262 55.3723 40.1694 55.0893 41.2044L54.6204 42.9325C54.4303 43.6339 54.6545 44.3393 55.2137 44.8001L56.086 45.5165C56.9159 46.2028 56.9692 47.4387 56.2104 48.1948L54.9389 49.454C54.4235 49.9653 54.2649 50.6899 54.5206 51.368L54.9157 52.4262C55.2917 53.4339 54.7215 54.5303 53.6838 54.8051L51.9557 55.2618C51.2503 55.4477 50.754 55.9946 50.6336 56.711L50.4477 57.8239C50.27 58.8862 49.2268 59.552 48.1919 59.269L46.4637 58.8001C45.7624 58.61 45.0569 58.8356 44.5962 59.3934L43.8797 60.2657C43.1934 61.0956 41.9575 61.1489 41.2014 60.3901L39.9422 59.1186C39.4309 58.6032 38.7063 58.4487 38.0282 58.7003L36.97 59.0954C35.9624 59.4713 34.8659 58.9053 34.5911 57.8635L34.1344 56.1354C33.9485 55.434 33.4016 54.9337 32.6852 54.8133L31.5723 54.6274C30.51 54.4497 29.8442 53.4106 30.1272 52.3715L30.5962 50.6434C30.7862 49.9421 30.5606 49.2366 30.0028 48.7758L29.1305 48.0594C28.3006 47.3731 28.2473 46.1372 29.0061 45.3811L30.2776 44.1219C30.793 43.6106 30.9475 42.886 30.696 42.2079L30.3008 41.1497C29.9249 40.1421 30.4909 39.0456 31.5327 38.7708L33.2608 38.3141C33.9622 38.1282 34.4626 37.5813 34.5829 36.8649L34.7688 35.752C34.9465 34.6897 35.9856 34.0239 37.0247 34.3069L38.7528 34.7758C39.4542 34.9659 40.1555 34.7403 40.6204 34.1825L41.3368 33.3102C42.0217 32.4817 43.2536 32.427 44.0137 33.1858Z"
      fill="#FF4646"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.6076 54.723C46.9758 54.723 50.54 51.1615 50.54 46.7893C50.54 42.4211 46.9744 38.8555 42.6076 38.8555C38.2354 38.8555 34.6738 42.4211 34.6738 46.7893C34.6738 51.1615 38.2354 54.723 42.6076 54.723Z"
      fill="#FFD400"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.3018 52.8774C37.5613 51.424 36.4539 49.2338 36.4539 46.7893C36.4539 46.2821 36.5045 45.7817 36.5934 45.3004C36.9652 43.3467 38.0508 41.65 39.5697 40.4865C40.6826 39.6334 42.0307 39.0688 43.499 38.9047C43.2051 38.8692 42.9098 38.8541 42.6076 38.8541C41.7244 38.8541 40.8713 38.9977 40.077 39.2643C36.9338 40.3225 34.6738 43.2906 34.6738 46.7865C34.6738 46.9301 34.6779 47.0778 34.6848 47.2172C34.6848 47.2637 34.6889 47.3102 34.693 47.3526C34.8475 49.5688 35.9139 51.5348 37.5217 52.8746C38.8971 54.0258 40.6689 54.719 42.6063 54.719C42.9084 54.719 43.2037 54.7039 43.4977 54.6684C41.9104 54.4975 40.4639 53.8508 39.3018 52.8774Z"
      fill="#E6BF00"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.6941 58.8274V68.9583C37.6941 69.1565 37.7912 69.326 37.958 69.4231L37.3072 69.8961C37.1363 70.0165 36.9271 70.0356 36.7412 69.9385C36.5553 69.8456 36.4473 69.6678 36.4473 69.4586V59.2116C36.6223 59.2006 36.7959 59.1651 36.9709 59.0995L37.6941 58.8274ZM48.7697 69.1155V69.4559C48.7697 69.6651 48.6617 69.8428 48.4758 69.9358C48.2898 70.0329 48.0807 70.0137 47.9098 69.8934L42.9264 66.2772C42.9154 66.2649 42.899 66.2581 42.8881 66.2499L43.5389 65.7768C43.7289 65.6374 43.9805 65.6374 44.1746 65.7768L48.7697 69.1155Z"
      fill="#E5972D"
    />
    <path
      d="M45.4673 8.34805C45.9089 7.90645 46.6226 7.90645 47.0642 8.34805C47.5017 8.78555 47.5017 9.50332 47.0642 9.94492L44.7892 12.2158C44.3517 12.6574 43.6339 12.6574 43.1923 12.2158L41.6105 10.6313C41.1689 10.1896 41.1689 9.47598 41.6105 9.03438C42.048 8.59277 42.7658 8.59277 43.2074 9.03438L43.9908 9.82051L45.4673 8.34805ZM45.4673 22.2387C45.9089 21.7971 46.6226 21.7971 47.0642 22.2387C47.5017 22.6762 47.5017 23.3939 47.0642 23.8355L44.7892 26.1064C44.3517 26.548 43.6339 26.548 43.1923 26.1064L41.6105 24.5205C41.1689 24.0789 41.1689 23.3652 41.6105 22.9236C42.048 22.482 42.7658 22.482 43.2074 22.9236L43.9908 23.7098L45.4673 22.2387Z"
      fill="white"
    />
  </svg>
);

const experienceSVG = (
  <svg
    width="60"
    height="60"
    viewBox="0 0 70 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.0497 56.309C16.1716 60.5829 22.7295 61.783 29.9998 60.2684C37.4384 58.7189 45.5849 54.3419 52.6788 47.505L52.677 47.5033C52.6995 47.4808 52.7226 47.4598 52.7462 47.4398C59.8129 40.6072 64.4678 32.6399 66.2822 25.2751C68.0587 18.0643 67.096 11.4667 62.9728 7.19147C58.8509 2.91764 52.293 1.71753 45.0227 3.2321C37.5789 4.7829 29.426 9.16473 22.3284 16.0101L22.3273 16.0112C15.2318 22.8549 10.5591 30.843 8.74015 38.2255C6.96363 45.4364 7.9264 52.034 12.0496 56.309H12.0497ZM30.4443 62.4047C22.4461 64.071 15.1584 62.6748 10.4776 57.8214C5.79796 52.9694 4.66689 45.6368 6.62128 37.7041C8.52796 29.9648 13.3894 21.621 20.7553 14.4968C20.7926 14.4549 20.8331 14.4158 20.8763 14.38C28.261 7.27747 36.7749 2.72132 44.5784 1.09559C52.5766 -0.570736 59.8642 0.825436 64.5451 5.67868C69.2247 10.5307 70.3557 17.8633 68.4013 25.796C66.4947 33.5353 61.6332 41.8791 54.2674 49.0033C54.23 49.0453 54.1896 49.0843 54.1462 49.1201C46.7615 56.2226 38.2476 60.7788 30.4441 62.4045L30.4443 62.4047Z"
      fill="#64B5F6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M64.5432 57.8213C59.8624 62.6747 52.5747 64.0707 44.5766 62.4045C36.7729 60.7788 28.259 56.2228 20.8744 49.1201C20.8311 49.0843 20.7906 49.0453 20.7533 49.0033C13.3875 41.8791 8.52601 33.5353 6.61933 25.796C4.66494 17.8633 5.79601 10.5307 10.4756 5.67868C15.1566 0.825436 22.4441 -0.570736 30.4424 1.09559C38.2459 2.72118 46.76 7.27733 54.1445 14.38C54.1879 14.4157 54.2282 14.4548 54.2655 14.4968C61.6314 21.621 66.4928 29.9648 68.3995 37.7041C70.3539 45.6368 69.2228 52.9693 64.5432 57.8214V57.8213ZM45.0209 60.2683C52.2912 61.7829 58.849 60.5827 62.971 56.3089C67.0941 52.0339 68.0569 45.4362 66.2804 38.2254C64.4616 30.8429 59.7887 22.8547 52.6933 16.0111L52.6922 16.01C45.5947 9.1646 37.4418 4.78262 29.9978 3.23196C22.7275 1.71739 16.1697 2.91751 12.0477 7.19133C7.92458 11.4664 6.96168 18.064 8.73834 25.275C10.5529 32.6398 15.2077 40.607 22.2744 47.4397C22.2981 47.4597 22.3212 47.4808 22.3436 47.5031L22.3419 47.5049C29.4358 54.3418 37.5823 58.7187 45.0209 60.2683Z"
      fill="#FC685B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3195 38.7916V42.08C12.3195 43.099 11.4875 43.9312 10.4685 43.9312H9.15572C8.13676 43.9312 7.30469 43.0995 7.30469 42.08V39.5291L12.3195 38.7916Z"
      fill="#788A98"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3188 38.7916V42.0799C12.3188 43.0988 11.4868 43.931 10.4678 43.931H9.15504C8.3417 43.931 7.64744 43.4011 7.40039 42.6687C7.67943 42.8375 8.00605 42.935 8.35469 42.935H9.66746C10.6864 42.935 11.5185 42.1028 11.5185 41.0839V38.9093L12.3188 38.7916Z"
      fill="#6C7E8D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.81162 18.6091C14.8529 18.6091 18.9395 22.6959 18.9395 27.7369C18.9395 31.0734 17.1496 33.9919 14.4776 35.5839C13.9016 35.9272 13.5738 36.5034 13.5738 37.174V39.3997C13.5738 40.0908 13.0102 40.6545 12.319 40.6545H7.30406C6.61295 40.6545 6.04926 40.0908 6.04926 39.3997V37.174C6.04926 36.5033 5.72168 35.9272 5.14568 35.5839C2.47365 33.9918 0.683594 31.0734 0.683594 27.7369C0.683594 22.6958 4.77039 18.6091 9.81162 18.6091Z"
      fill="#FFDA2D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.81147 18.6091C14.8527 18.6091 18.9394 22.6958 18.9394 27.7369C18.9394 30.6352 17.5884 33.218 15.4821 34.8899C16.7178 33.3327 17.456 31.3627 17.456 29.2202C17.456 24.1791 13.3693 20.0924 8.32807 20.0924C6.18541 20.0924 4.21543 20.8311 2.6582 22.067C4.33027 19.9603 6.91289 18.609 9.81147 18.609V18.6091ZM13.6485 36.638C13.5993 36.8074 13.5737 36.987 13.5737 37.174V39.3997C13.5737 40.0908 13.01 40.6545 12.319 40.6545H12.0904V38.6574C12.0904 37.9868 12.418 37.4106 12.994 37.0673C13.2186 36.9334 13.4368 36.79 13.6485 36.638Z"
      fill="#FFC700"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.625 29.4044C8.625 28.7491 9.15629 28.2177 9.81172 28.2177C10.4671 28.2177 10.9984 28.7489 10.9984 29.4044V36.8725C10.9984 37.5279 10.4671 38.0592 9.81172 38.0592C9.15629 38.0592 8.625 37.5279 8.625 36.8725V29.4044Z"
      fill="#FDB800"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.81182 29.98C10.941 29.98 11.8619 29.059 11.8619 27.9299C11.8619 26.8007 10.941 25.8798 9.81182 25.8798C8.68266 25.8798 7.76172 26.8007 7.76172 27.9299C7.76172 29.059 8.68266 29.98 9.81182 29.98Z"
      fill="#FDB800"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.8116 25.8798C10.9438 25.8798 11.8617 26.7977 11.8617 27.9299C11.8617 28.6355 11.5051 29.2578 10.9624 29.6267C11.2178 29.2847 11.369 28.8606 11.369 28.4011C11.369 27.269 10.451 26.351 9.31887 26.351C8.8923 26.351 8.49609 26.4813 8.16797 26.7043C8.54176 26.2039 9.13881 25.8798 9.8116 25.8798Z"
      fill="#F4A40E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.5746 39.3997V37.174C13.5746 37.0711 13.5823 36.9705 13.5975 36.8724H6.02734C6.04252 36.9703 6.05018 37.0711 6.05018 37.174V39.3997C6.05018 40.0908 6.61387 40.6545 7.30498 40.6545H12.32C13.0111 40.6545 13.5746 40.0908 13.5746 39.3997Z"
      fill="#96A4AF"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.574 39.3997V37.174C13.574 37.0711 13.5816 36.9705 13.5968 36.8724H12.8774V38.7386C12.8774 39.4298 12.3137 39.9934 11.6226 39.9934H6.6076C6.44941 39.9934 6.29793 39.9638 6.1582 39.9099C6.35439 40.3478 6.79463 40.6542 7.30404 40.6542H12.319C13.0101 40.6542 13.5737 40.0905 13.5737 39.3994L13.574 39.3997ZM8.71648 37.3295C8.47531 37.2434 8.26996 37.0815 8.12955 36.8724H8.62516C8.62516 37.0344 8.6577 37.1888 8.71648 37.3295Z"
      fill="#8696A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.0704 28.8425H41.9503C46.1817 28.8425 49.6437 32.3045 49.6437 36.536V46.3592H25.377V36.536C25.377 32.3045 28.8389 28.8425 33.0704 28.8425Z"
      fill="#8757F3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M33.0704 28.8425H41.9503C43.6316 28.8425 45.1913 29.3895 46.4608 30.314C45.8466 30.1549 45.2035 30.07 44.5414 30.07H35.6615C31.43 30.07 27.968 33.532 27.968 37.7634V46.3592H25.377V36.536C25.377 32.3045 28.8389 28.8425 33.0704 28.8425Z"
      fill="#723AF0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.5101 30.9083C41.3013 30.9083 44.3933 27.8163 44.3933 24.0252C44.3933 20.2341 41.3013 17.1421 37.5101 17.1421C33.7188 17.1421 30.627 20.2341 30.627 24.0252C30.627 27.8163 33.719 30.9083 37.5101 30.9083Z"
      fill="#FFD6BD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.5099 17.1421C39.821 17.1421 41.8658 18.2811 43.1142 20.0284C41.9875 19.2234 40.6077 18.7495 39.1173 18.7495C35.3159 18.7495 32.2342 21.8311 32.2342 25.6326C32.2342 27.123 32.7081 28.5027 33.5132 29.6296C31.766 28.3813 30.627 26.3363 30.627 24.0252C30.627 20.2237 33.7086 17.1421 37.5101 17.1421H37.5099Z"
      fill="#F9C6AA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.1708 6.78662L54.2924 11.8335L59.7479 12.2916L55.6036 15.8688L56.8537 21.1988L52.1708 18.363L47.488 21.1988L48.7381 15.8688L44.5938 12.2916L50.0492 11.8335L52.1708 6.78662Z"
      fill="#FFDA2D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M52.1707 6.78662L52.8543 8.41275L51.4163 11.8335L45.9608 12.2916L50.105 15.8688L49.0813 20.2339L47.4878 21.1988L48.738 15.8688L44.5938 12.2916L50.0492 11.8335L52.1707 6.78662ZM56.6272 20.2339L53.5379 18.363L52.8543 18.777L56.8536 21.199L56.6273 20.234L56.6272 20.2339Z"
      fill="#FFC700"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M37.5107 65.5778C41.1225 65.5778 44.0684 62.632 44.0684 59.0201C44.0684 55.4083 41.1225 52.4624 37.5107 52.4624C33.8989 52.4624 30.9531 55.4083 30.9531 59.0201C30.9531 62.632 33.899 65.5778 37.5107 65.5778Z"
      fill="#64B5F6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M42.7809 62.9235C41.5862 64.5343 39.6704 65.5783 37.5108 65.5783C33.8892 65.5783 30.9531 62.6424 30.9531 59.0206C30.9531 56.861 31.9972 54.9454 33.6081 53.7505C32.7991 54.841 32.3203 56.1912 32.3203 57.6534C32.3203 61.2751 35.2562 64.2111 38.878 64.2111C40.3401 64.2111 41.6903 63.7325 42.7809 62.9235Z"
      fill="#42A5F5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M40.1794 56.021C40.604 55.5939 41.2947 55.592 41.7217 56.0168C42.1488 56.4416 42.1507 57.1322 41.7259 57.5591L37.3073 62.0192C36.8854 62.4434 36.2014 62.4481 35.7736 62.0319L33.3087 59.6295C32.8769 59.2095 32.8674 58.5189 33.2874 58.0871C33.7074 57.6554 34.3979 57.6458 34.8297 58.0658L36.5206 59.7141L40.1792 56.0212L40.1794 56.021Z"
      fill="#E6F8FF"
    />
  </svg>
);
